export const LOGIN = "admin/login";

export const SIGN_UP = "user/auth/signup";

export const CHANGE_PASSWORD = 'admin/chnagePassword';

export const DASHBOARD = 'admin/auth/dashboard';


